export const headerReport = [
    {label:"Doanh số theo ngày", route:"daily", icon:"fa-solid fa-chart-bar"},
    {label:"Doanh số theo chi nhánh", route:"locations", icon:"fa-solid fa-location-dot"},
    {label:"Tiền thu từng dịch vụ", route:"service-detail", icon:"fa-solid fa-tags"},
    {label:"Báo cáo tổng quan Sale", route:"online", icon:"fa-solid fa-user-large"},
    {label:"Báo cáo lễ tân", route:"offline-lt", icon:"fa-solid fa-user-group"},
    {label:"Báo cáo tư vấn & phục vụ offline", route:"offline-ktv-tvv", icon:"fa-solid fa-user-large"},
    {label:"Chi tiết Sale", route:"detail/sale-ctm", icon:"fa-solid fa-tags"},
    {label:"Chi tiết KTV", route:"detail/ktv-tvv", icon:"fa-solid fa-location-dot"},
    {label:"Hiệu quả promotion", route:"promotion", icon:"fa-solid fa-tags"},
    {label:"Chi tiết promotion", route:"detail-promotion", icon:"fa-solid fa-user-large"},
    {label:"Vận hành cơ sở", route:"operate-booking", icon:"fa-solid fa-user-large"},
    {label:"Kinh doanh cơ sở", route:"business", icon:"fa-solid fa-location-dot"},
    {label:"Khách hàng liệu trình", route:"customer-course", icon:"fa-solid fa-id-card"},
    {label:"Khách hàng mới", route:"customer-new", icon:"fa-solid fa-user-plus"},
    {label:"Upsale / Mua thêm", route:"upsale", icon:"fa-solid fa-cart-plus"},
    {label:"Tiền thu dự kiến", route:"expected-cash", icon:"fa-solid fa-coins"},
    {label:"Thu nợ", route:"debt-collection", icon:"fa-solid fa-file-invoice-dollar"},
    {label:"Hành vi mua hàng", route:"purchase-behavior", icon:"fa-solid fa-chart-pie"},
    {label:"Tư vấn cơ sở theo ngày", route:"ktv-tv-details", icon:"fa-solid fa-user-large"},
    {label:"Bảng chi tiết từng KTV", route:"ktv-tvv-detail", icon:"fa-solid fa-user-group"},
    {label:"Doanh thu dự kiến", route:"total-price-booking", icon:"fa-solid fa-user-large"},
    {label:"Dịch vụ nâng cấp", route:"hopper", icon:"fa-solid fa-user-large"},
    {label:"Phục vụ chéo", route:"service-do-housework", icon:"fas fa-user-friends"},
    {label:"Dòng tiền chéo", route:"customer-paid-store", icon:"fas fa-sack-dollar"},
    {label:"Theo dõi BHVV", route:"bhvv-flow", icon:"fas fa-sack-dollar"},
]

export const headerPillar = [
    {label:"Độc lập", route:"independence", icon:"fas fa-chart-line"},
    {label:"Tự do", route:"freedom", icon:"fas fa-chart-bar"},
    {label:"Hạnh phúc", route:"happiness", icon:"fas fa-chart-area"}
]